import { GridColDef } from "@mui/x-data-grid-premium";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiOpenProcessMenu from "src/components/core-components/mui/ByzMuiOpenProcessMenu";
import { useTranslate } from "src/locales";

//CKAPISIZ;452424;05052024
export const usePageColumns = (): GridColDef[] => {
  const { t } = useTranslate();
  return getColumns(t);
};

export const getColumns = (t: (key: string) => string): GridColDef[] => [
  {
    field: "select",
    headerName: t("patient-diet-procedures.pages.select"),
    width: 60,
    sortable: false,
    filterable: false,
    renderCell: () => (
      <>
        <ByzMuiCheckBox />
        <ByzMuiOpenProcessMenu
          menuItems={[
            {
              label: t("patient-diet-procedures.favorites.add-favorites"),
              onClick() {},
            },
            {
              label: t("patient-diet-procedures.favorites.delete-favorites"),
              onClick() {},
            },
          ]}
          hideHeaderTitle
        />
      </>
    ),
  },
  {
    field: "select2",
    headerName: "",
    width: 60,
    sortable: false,
    filterable: false,
    renderCell: () => (
      <ByzMuiOpenProcessMenu
        menuItems={[
          {
            label: t("patient-diet-procedures.favorites.add-favorites"),
            onClick() {},
            disabled: true,
          },
          {
            label: t("patient-diet-procedures.favorites.delete-favorites"),
            onClick() {
              console.log("Sık Kullanılanlardan Çıkarıldı.");
            },
          },
        ]}
        hideHeaderTitle
      />
    ),
  },
  {
    field: "sube",
    headerName: t("patient-diet-procedures.pages.branch"),
    width: 150,
  },
  {
    field: "ogun",
    headerName: t("patient-diet-procedures.pages.meal"),
    width: 120,
  },
  {
    field: "diyetTipi",
    headerName: t("patient-diet-procedures.pages.diet-type"),
    width: 150,
  },
  {
    field: "adi",
    headerName: t("patient-diet-procedures.pages.name"),
    width: 150,
  },
  {
    field: "not",
    headerName: t("patient-diet-procedures.pages.note"),
    width: 150,
  },
  {
    field: "diyabetik",
    headerName: t("patient-diet-procedures.pages.diabetic"),
    width: 100,
    sortable: false,
    filterable: false,
    renderCell: () => <ByzMuiCheckBox circular />,
  },
  {
    field: "sonIstemTarihi",
    headerName: t("patient-diet-procedures.pages.last-request-date"),
    width: 150,
  },
];

export const rows = [
  {
    id: 1,
    sube: "Yazılım Test Hastanesi",
    ogun: "Sabah",
    diyetTipi: "Normal",
    adi: "Normal",
    not: "",
    sonIstemTarihi: "10:00",
  },
  {
    id: 2,
    sube: "Yazılım Test Hastanesi",
    ogun: "Sabah",
    diyetTipi: "Normal",
    adi: "Sulu Yemek",
    not: "",
    sonIstemTarihi: "10:00",
  },
  {
    id: 3,
    sube: "Yazılım Test Hastanesi",
    ogun: "Öğlen",
    diyetTipi: "Diyet Rasyon",
    adi: "R1",
    not: "",
    sonIstemTarihi: "10:00",
  },
  {
    id: 4,
    sube: "Yazılım Test Hastanesi",
    ogun: "Öğlen",
    diyetTipi: "Diyet R2",
    adi: "R2",
    not: "",
    sonIstemTarihi: "10:00",
  },
  {
    id: 5,
    sube: "Yazılım Test Hastanesi",
    ogun: "Akşam",
    diyetTipi: "Vegan Diyet",
    adi: "R3",
    not: "",
    sonIstemTarihi: "10:00",
  },
  {
    id: 6,
    sube: "Yazılım Test Hastanesi",
    ogun: "Akşam",
    diyetTipi: "Vegan",
    adi: "R3",
    not: "",
    sonIstemTarihi: "10:00",
  },
  {
    id: 7,
    sube: "Yazılım Test Hastanesi",
    ogun: "Akşam",
    diyetTipi: "Normal",
    adi: "R4 Mix",
    not: "",
    sonIstemTarihi: "10:00",
  },
];
